import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';
import update from 'immutability-helper';
import DropdownList from '../common/DropdownList';
import ConsultantInterest from '../ConsultantInterest';
import './RepProjectApplicationActions.scss';
import { analyticsTrack } from '../../analyticsUtils';
var activeApplications = function activeApplications(applications) {
  return applications.filter(function (application) {
    return !application.rejected && !application.waitlisted;
  });
};
var rejectedApplications = function rejectedApplications(applications) {
  return applications.filter(function (application) {
    return application.rejected;
  });
};
var waitlistedApplications = function waitlistedApplications(applications) {
  return applications.filter(function (application) {
    return application.waitlisted;
  });
};
var dedupApplications = function dedupApplications(interests, proposals) {
  var userIdsProposals = proposals.map(function (proposal) {
    return proposal.consultant_id;
  });
  return interests.filter(function (interest) {
    return !userIdsProposals.includes(interest.user_id);
  });
};
var renderProposalAction = function renderProposalAction(proposal) {
  if (proposal.rehireable && proposal.rep_rehire_url) {
    return /*#__PURE__*/React.createElement(Row, {
      className: "row mb-0"
    }, /*#__PURE__*/React.createElement(Col, {
      className: "mb-0",
      xs: 6
    }, /*#__PURE__*/React.createElement("a", {
      href: proposal.rep_rehire_url,
      className: "btn btn-secondary full-width edit-btn",
      onClick: function onClick() {
        analyticsTrack('Consultant hired again', {
          location: 'Project Show Page',
          consultant: proposal.consultant.name
        });
      }
    }, "Hire Again")), /*#__PURE__*/React.createElement(Col, {
      className: "mb-0",
      xs: 6
    }, /*#__PURE__*/React.createElement("a", {
      href: proposal.review_proposal_url,
      className: "btn btn-primary full-width review-btn"
    }, "Review")));
  }
  if (proposal.editable) {
    return /*#__PURE__*/React.createElement(Row, {
      className: "row mb-0"
    }, /*#__PURE__*/React.createElement(Col, {
      className: "mb-0",
      xs: 6
    }, /*#__PURE__*/React.createElement("a", {
      href: proposal.edit_url,
      className: "btn btn-secondary full-width edit-btn"
    }, "Edit")), /*#__PURE__*/React.createElement(Col, {
      className: "mb-0",
      xs: 6
    }, /*#__PURE__*/React.createElement("a", {
      href: proposal.review_proposal_url,
      className: "btn btn-primary full-width review-btn"
    }, "Review")));
  }
  return /*#__PURE__*/React.createElement("a", {
    href: proposal.review_proposal_url,
    className: "btn btn-primary full-width review-btn"
  }, "Review");
};
var renderLogistics = function renderLogistics(daysAgo, fromOpportunity) {
  return /*#__PURE__*/React.createElement("div", {
    className: " mb-3 "
  }, fromOpportunity && /*#__PURE__*/React.createElement("span", {
    className: "badge badge-fallback-tertiary me-3 normal-font pull-right"
  }, "OpenOpps"), /*#__PURE__*/React.createElement("p", null, daysAgo));
};
var renderProposalDetails = function renderProposalDetails(proposal) {
  return /*#__PURE__*/React.createElement("div", {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement("p", {
    className: "demibold"
  }, proposal.status), /*#__PURE__*/React.createElement("h3", {
    className: "fs-hide normal-weight"
  }, /*#__PURE__*/React.createElement("a", {
    href: proposal.consultant_url
  }, proposal.consultant_name), /*#__PURE__*/React.createElement("a", {
    href: proposal.clorify_url,
    target: "_blank",
    rel: "noreferrer"
  }, " (view Clorify)")));
};
var RepProjectApplicationActions = /*#__PURE__*/function (_Component) {
  function RepProjectApplicationActions(props) {
    var _this;
    _classCallCheck(this, RepProjectApplicationActions);
    _this = _callSuper(this, RepProjectApplicationActions, [props]);
    _this.state = {
      consultantInterests: dedupApplications(activeApplications(props.consultantInterests), props.proposals),
      proposals: activeApplications(props.proposals),
      rejectedConsultantInterests: rejectedApplications(props.consultantInterests),
      waitlistedConsultantInterests: waitlistedApplications(props.consultantInterests),
      rejectedProposals: rejectedApplications(props.proposals),
      updated: false
    };
    _this.handleRejectInterest = _this.handleRejectInterest.bind(_this);
    _this.handleWaitlistInterest = _this.handleWaitlistInterest.bind(_this);
    _this.createdProposal = _this.createdProposal.bind(_this);
    return _this;
  }
  _inherits(RepProjectApplicationActions, _Component);
  return _createClass(RepProjectApplicationActions, [{
    key: "handleRejectInterest",
    value: function handleRejectInterest(interest) {
      var _this$state = this.state,
        consultantInterests = _this$state.consultantInterests,
        rejectedConsultantInterests = _this$state.rejectedConsultantInterests;
      var interestIndex = consultantInterests.findIndex(function (i) {
        return i.id === interest.id;
      });
      var newConsultantInterests = update(consultantInterests, {
        $splice: [[interestIndex, 1]]
      });
      var newRejectedInterests = update(rejectedConsultantInterests, {
        $push: [interest]
      });
      this.setState({
        consultantInterests: newConsultantInterests,
        rejectedConsultantInterests: newRejectedInterests
      });
    }
  }, {
    key: "handleWaitlistInterest",
    value: function handleWaitlistInterest(interest) {
      var _this$state2 = this.state,
        consultantInterests = _this$state2.consultantInterests,
        waitlistedConsultantInterests = _this$state2.waitlistedConsultantInterests;
      var interestIndex = consultantInterests.findIndex(function (i) {
        return i.id === interest.id;
      });
      var newConsultantInterests = update(consultantInterests, {
        $splice: [[interestIndex, 1]]
      });
      var newInterest = _objectSpread({}, interest);
      newInterest.waitlisted = true;
      var newWaitlistedInterests = update(waitlistedConsultantInterests, {
        $push: [newInterest]
      });
      this.setState({
        consultantInterests: newConsultantInterests,
        waitlistedConsultantInterests: newWaitlistedInterests
      });
    }
  }, {
    key: "createdProposal",
    value: function createdProposal(data) {
      this.setState({
        consultantInterests: dedupApplications(activeApplications(data.interests), data.proposals),
        proposals: activeApplications(data.proposals)
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        createProposalPath = _this$props.createProposalPath,
        csrfToken = _this$props.csrfToken,
        rep = _this$props.rep,
        opportunitiesUrl = _this$props.opportunitiesUrl,
        projectUrl = _this$props.projectUrl;
      var _this$state3 = this.state,
        consultantInterests = _this$state3.consultantInterests,
        proposals = _this$state3.proposals,
        rejectedConsultantInterests = _this$state3.rejectedConsultantInterests,
        waitlistedConsultantInterests = _this$state3.waitlistedConsultantInterests,
        rejectedProposals = _this$state3.rejectedProposals;
      return /*#__PURE__*/React.createElement("div", {
        className: "rep-project-proposal-view style-guide"
      }, consultantInterests.length > 0 && /*#__PURE__*/React.createElement(DropdownList, {
        title: "".concat(consultantInterests.length, " resume").concat(consultantInterests.length > 1 ? 's' : ''),
        dropdownClass: "count-header"
      }, /*#__PURE__*/React.createElement("div", {
        className: "consultant-interest-list"
      }, consultantInterests.map(function (interest) {
        return /*#__PURE__*/React.createElement(ConsultantInterest, {
          key: interest.id,
          interest: interest,
          createProposalPath: createProposalPath,
          csrfToken: csrfToken,
          rep: rep,
          opportunitiesUrl: opportunitiesUrl,
          projectUrl: projectUrl,
          createdProposal: _this2.createdProposal,
          rejectedCallback: _this2.handleRejectInterest,
          waitlistedCallback: _this2.handleWaitlistInterest,
          clorifyUrl: interest.consultant_clorify_url,
          project: interest.project,
          resume: interest.resume
        });
      }))), waitlistedConsultantInterests.length > 0 && /*#__PURE__*/React.createElement(DropdownList, {
        title: "".concat(waitlistedConsultantInterests.length, " waitlist"),
        dropdownClass: "count-header"
      }, /*#__PURE__*/React.createElement("div", {
        className: "wait-list"
      }, /*#__PURE__*/React.createElement("div", {
        className: "consultant-interest-list"
      }, waitlistedConsultantInterests.map(function (interest) {
        return /*#__PURE__*/React.createElement(ConsultantInterest, {
          key: interest.id,
          interest: interest,
          createProposalPath: createProposalPath,
          csrfToken: csrfToken,
          rep: rep,
          opportunitiesUrl: opportunitiesUrl,
          projectUrl: projectUrl,
          createdProposal: _this2.createdProposal,
          rejectedCallback: _this2.handleRejectInterest,
          waitlistedCallback: _this2.handleWaitlistInterest,
          clorifyUrl: interest.consultant_clorify_url,
          project: interest.project
        });
      })))), /*#__PURE__*/React.createElement(DropdownList, {
        title: "".concat(proposals.length, " proposal").concat(proposals.length !== 1 ? 's' : ''),
        dropdownClass: "count-header"
      }, /*#__PURE__*/React.createElement("div", {
        className: "proposal-list"
      }, proposals.map(function (proposal) {
        return /*#__PURE__*/React.createElement("div", {
          className: "proposal"
        }, renderLogistics(proposal.days_ago, proposal.from_opportunity), renderProposalDetails(proposal), renderProposalAction(proposal));
      }))), /*#__PURE__*/React.createElement(DropdownList, {
        title: "".concat(rejectedConsultantInterests.length + rejectedProposals.length, " rejected"),
        dropdownClass: "count-header"
      }, /*#__PURE__*/React.createElement("div", {
        className: "rejected-list"
      }, /*#__PURE__*/React.createElement("div", {
        className: "proposal-list"
      }, rejectedProposals.map(function (proposal) {
        return /*#__PURE__*/React.createElement("div", {
          className: "proposal"
        }, renderLogistics(proposal.days_ago, proposal.from_opportunity), renderProposalDetails(proposal), /*#__PURE__*/React.createElement("a", {
          href: proposal.review_proposal_url,
          className: "btn btn-primary full-width proposal-rejected"
        }, "View Proposal"));
      })), /*#__PURE__*/React.createElement("div", {
        className: "consultant-interest-list"
      }, rejectedConsultantInterests.map(function (interest) {
        return /*#__PURE__*/React.createElement(ConsultantInterest, {
          key: interest.id,
          interest: interest,
          createProposalPath: createProposalPath,
          csrfToken: csrfToken,
          rep: rep,
          opportunitiesUrl: opportunitiesUrl,
          projectUrl: projectUrl,
          rejectedCallback: _this2.handleRejectInterest,
          waitlistedCallback: _this2.handleWaitlistInterest,
          clorifyUrl: interest.consultant_clorify_url,
          project: interest.project
        });
      })))));
    }
  }]);
}(Component);
RepProjectApplicationActions.propTypes = {
  consultantInterests: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  proposals: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  csrfToken: PropTypes.string.isRequired,
  rep: PropTypes.string.isRequired,
  opportunitiesUrl: PropTypes.string.isRequired,
  projectUrl: PropTypes.string.isRequired,
  createProposalPath: PropTypes.string.isRequired
};
export default RepProjectApplicationActions;